import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SupportedLocaleCode } from '@ttc/ttc-constants/locale';

export interface SSOSignInParams {
  destination?: string;
  inviteCode?: string;
  pathwayMembershipId?: string;
  preRegistrationId?: string;
  selected_locale?: SupportedLocaleCode;
  signup_method?: string;
  signup_method_details?: string;
  ssoConnectionId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class WorkOsBackend {
  constructor(public http: HttpClient) {}

  authenticate(signInParams?: SSOSignInParams) {
    return this.http.get<{ authorizationUrl: string }>(
      '/api/v3/workos/sso/auth',
      { params: { ...signInParams } },
    );
  }
}
